import { useEffect, useState } from "react";
import { getBrowserInfo, getOSInfo } from "./environment";

export const useEnvironmentCheck = () => {
    const [showBrowserWarning, setShowBrowserWarning] = useState(false);
    const [showOSWarning, setShowOSWarning] = useState(false);
    const [osType, setOsType] = useState<string | null>(null);

    useEffect(() => {
        const { isChrome } = getBrowserInfo();
        const os = getOSInfo();

        const isMobile = os.type === "mobile";

        // Alert SO
        if (
            os.type === "mobile" ||
            os.type === "windows_old"
        ) {
            const osStorageKey = `hideOSWarning_${os.type}`;

            setOsType(os.type);

            if (localStorage.getItem(osStorageKey) !== "true") {
                setShowOSWarning(true);
            }
        }

        // Alert browser
        if (!isMobile && !isChrome) {
            if (localStorage.getItem("hideBrowserWarning") !== "true") {
                setShowBrowserWarning(true);
            }
        }
    }, []);

    return {
        showBrowserWarning,
        showOSWarning,
        osType,
        storageKey: osType ? `hideOSWarning_${osType}` : null
    };
};